/**
 * MSAL instance for reuse across the app
 */
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "./msalConfig";

// Create a single MSAL instance to reuse
export const msalInstance = new PublicClientApplication(msalConfig);

// Init MSAL right away (do not auto-login; user triggers login via UI)
(async () => {
  try {
    // This must be called and awaited before any other MSAL methods
    await msalInstance.initialize();
    
    // Handle any redirects after init is done
    await msalInstance.handleRedirectPromise();
    console.log("MSAL ready!");
  } catch (error) {
    console.error("MSAL init failed:", error);
  }
})();
